import gql from 'graphql-tag';

export const BULK_ACTION_BOOST_REWARDS_MUTATION = gql`
mutation BulkActionBoostRewards($action: BoostRewardAction!, $boostRewardIds: [Int!]!) {
    bulkActionBoostRewards(action: $action, boostRewardIds: $boostRewardIds)
}
`;
